import $axios from './apiConnection'
import parseCatch from '@/helpers/handleErrors.js'
import { redirectToLogin } from '@/composables/useCurrentUserData'
import { EntitiesListResponse } from '@/types/api'

export const entitiesApi = {
    async getList () {
        try {
            const { Data } = await $axios.get('/Login/EntitiesList/') as EntitiesListResponse
            return Data
        } catch (e) {
            redirectToLogin()
            parseCatch(e, false, 'Entities List')
        }
    },

    async getListByPath (path: string) {
        try {
            const { Data } = await $axios.get(path)
            return Data
        } catch (e) {
            return []
        }
    },
    async getSelectedAccountList (accountId: number) {
        try {
            const { Data } = await $axios.get('/Login/EntitiesList/', {
                headers: {
                    'x-selected-account': accountId,
                },
            }) as EntitiesListResponse
            return Data
        } catch (e) {
            parseCatch(e, false, 'Selected Account Entities List')
        }

    }
}
